import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const About = () => {
  const { t, language } = useLanguage();

  return (
    <div className="min-h-screen bg-[#F9F9F7] pt-32 pb-24" data-testid="about-page">
      <div className="max-w-[1200px] mx-auto px-6 md:px-12">
        <h1 className="text-lg font-sans font-bold uppercase tracking-tight leading-none text-[#1A1A1A] mb-12 text-center">
          {t('aboutUs')}
        </h1>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-24">
          <div>
            <img 
              src="https://images.unsplash.com/photo-1660675104528-c8d22837fe08?crop=entropy&cs=srgb&fm=jpg&q=85" 
              alt="Cosmo Beauty Story" 
              className="w-full h-full object-cover"
            />
          </div>
          <div className="flex flex-col justify-center">
            <h2 className="text-lg font-sans font-bold uppercase tracking-tight text-[#1A1A1A] mb-6">
              {t('ourStory')}
            </h2>
            <div className="space-y-4 text-base font-sans leading-relaxed text-[#8A8A8A]">
              {language === 'no' ? (
                <>
                  <p>
                    COSMOBEAUTY Mineral Makeup er utviklet i samarbeid med norske leger og makeupartister. Produktene inneholder kun naturlige tilsetningsstoffer og er 100 prosent rene.
                  </p>
                  <p>
                    Fint knust mica fra nordnorsk natur gir huden et mykt, naturlig lysreflekterende slør – i stedet for et tungt, dekkende lag. De fine mineralpartiklene fanger og reflekterer lyset, slik at huden får et jevnere, friskere og mer levende uttrykk uten den pudrete «maskeeffekten».
                  </p>
                  <p>
                    De unike mineralene gjør at sminken sitter utrolig godt mens huden blir tatt vare på. Ved bruk av mindre partikler som er knust 3 ganger mer i prosessen, blir huden glatt og legger seg ikke i fine linjer. Derfor kan den brukes av alle aldersgrupper.
                  </p>
                  <p>
                    Produktene inneholder ingen kjemikalier, alkohol og de er ikke testet på dyr. Alle produkter har en solfaktor på 15-20.
                  </p>
                </>
              ) : (
                <>
                  <p>
                    COSMOBEAUTY Mineral Makeup has been developed in collaboration with Norwegian doctors and makeup artists. The products contain only natural additives and it is 100 percent pure.
                  </p>
                  <p>
                    Finely crushed mica from northern Norwegian nature gives the skin a soft, naturally light-reflecting veil – instead of a heavy, covering layer. The fine mineral particles capture and reflect light, giving the skin a more even, fresher and more vibrant appearance without the powdery "mask effect".
                  </p>
                  <p>
                    The unique minerals make the makeup sit incredibly well while the skin is cared for. When using smaller particles that are crushed 3 times more in the process, the skin is left smooth and does not settle in fine lines. Therefore, it can be used by all age groups.
                  </p>
                  <p>
                    The products do not contain any chemicals, alcohol and they have not been tested on animals. All products have a sun factor of 15-20.
                  </p>
                </>
              )}
            </div>
          </div>
        </div>

        <div className="bg-white p-12 border border-[#E5E5E5]">
          <h2 className="text-lg font-sans font-bold uppercase tracking-tight text-[#1A1A1A] mb-8 text-center">
            {language === 'no' ? 'Hvorfor velge Cosmo Beauty?' : 'Why Choose Cosmo Beauty?'}
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <h3 className="text-lg font-sans font-bold uppercase text-[#1A1A1A] mb-3">
                {language === 'no' ? '100% Naturlig' : '100% Natural'}
              </h3>
              <p className="text-sm text-[#8A8A8A]">
                {language === 'no' 
                  ? 'Kun naturlige ingredienser uten kjemikalier'
                  : 'Only natural ingredients without chemicals'}
              </p>
            </div>
            <div className="text-center">
              <h3 className="text-lg font-sans font-bold uppercase text-[#1A1A1A] mb-3">
                {language === 'no' ? 'Norsk Kvalitet' : 'Norwegian Quality'}
              </h3>
              <p className="text-sm text-[#8A8A8A]">
                {language === 'no' 
                  ? 'Utviklet i Norge med medisinsk ekspertise'
                  : 'Developed in Norway with medical expertise'}
              </p>
            </div>
            <div className="text-center">
              <h3 className="text-lg font-sans font-bold uppercase text-[#1A1A1A] mb-3">
                {language === 'no' ? 'Dyrevennlig' : 'Cruelty-Free'}
              </h3>
              <p className="text-sm text-[#8A8A8A]">
                {language === 'no' 
                  ? 'Aldri testet på dyr'
                  : 'Never tested on animals'}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;